<template>
  <div class="flex gap-3 sm:gap-4 flex-wrap">
    <!-- Левая карточка -->
    <div class="grow lg:grow-0 lg:basis-[335px] rounded-xl flex flex-col justify-between p-4 glass-bg glass-bg-dark">
      <div class="flex justify-between items-center px-4">
        <span class="font-jakarta font-extrabold text-[20px]">Asset Allocation</span>
        <span class="p-3 bg-black bg-opacity-25 rounded-full font-inter text-[16px] text-cgreen">+2.93%</span>
      </div>
      <div class="mx-auto">
        <img src="/stima/assets/images/icons/banner-5/Chart.png" alt="">
      </div>
      <div class="banner-5-graph-items">
        <AssetGraphItem
            v-for="(item, index) in graphItems"
            :key="index"
            :label="item.label"
            :color="item.color"
            :image="item.image"
            :change="item.change"
            :change-class="item.changeClass"
            :arrow="item.arrow"
        />
      </div>
    </div>

    <!-- Правая карточка -->
    <div class="w-full lg:w-auto grow flex flex-col justify-between gap-3 px-4 py-6 rounded-xl glass-bg glass-bg-dark">
      <div class="px-4 py-3">
        <span class="font-jakarta font-extrabold text-[20px]">Top Performing Assets</span>
      </div>
      <div class="flex flex-col gap-1">
        <TopAssetItem
            v-for="(item, index) in topAssets"
            :key="index"
            :image="item.image"
            :title="item.title"
            :price="item.price"
            :change="item.change"
            :period="item.period"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import AssetGraphItem from './components/AssetGraphItem.vue'
import TopAssetItem from './components/TopAssetItem.vue'

const graphItems = [
  {
    label: 'Art',
    color: '#5E2164',
    image: '/stima/assets/images/icons/banner-5/red.png',
    change: '-10%',
    changeClass: 'text-cred',
    arrow: '/stima/assets/images/icons/banner-5/arrow-rotate-red.svg'
  },
  {
    label: 'Wine',
    color: '#FF007A',
    image: '/stima/assets/images/icons/banner-5/green.png',
    change: '480%',
    changeClass: 'text-cgreen',
    arrow: '/stima/assets/images/icons/banner-5/arrow-rotate-green.svg'
  },
  {
    label: 'Vehicles',
    color: '#FFB800',
    image: '/stima/assets/images/icons/banner-5/green.png',
    change: '480%',
    changeClass: 'text-cgreen',
    arrow: '/stima/assets/images/icons/banner-5/arrow-rotate-green.svg'
  },
  {
    label: 'Watches',
    color: '#00A4EB',
    image: '/stima/assets/images/icons/banner-5/green.png',
    change: '480%',
    changeClass: 'text-cgreen',
    arrow: '/stima/assets/images/icons/banner-5/arrow-rotate-green.svg'
  },
  {
    label: 'Others',
    color: '#868FAA',
    image: '/stima/assets/images/icons/banner-5/green.png',
    change: '480%',
    changeClass: 'text-cgreen',
    arrow: '/stima/assets/images/icons/banner-5/arrow-rotate-green.svg'
  }
]

const topAssets = [
  {
    image: '/stima/assets/images/icons/banner-5/img-1.png',
    title: 'LUCIO FONTANA Concetto Spaziale Bianco – Attese',
    price: '$1 800 000',
    change: '+28.5%',
    period: '30 days'
  },
  {
    image: '/stima/assets/images/icons/banner-5/img-2.png',
    title: 'Quintarelli – Valpolicella Superiore – 1993',
    price: '$15 000',
    change: '+22.1%',
    period: '30 days'
  },
  {
    image: '/stima/assets/images/icons/banner-5/img-3.png',
    title: 'Pink Star Diamond',
    price: '$185 000',
    change: '+19.8%',
    period: '30 days'
  },
  {
    image: '/stima/assets/images/icons/banner-5/img-4.png',
    title: 'MB&F LMX Paris Edition',
    price: '$124 000',
    change: '+17.2%',
    period: '30 days'
  },
  {
    image: '/stima/assets/images/icons/banner-5/img-5.png',
    title: '1946 Cadillac V16',
    price: '$200 000',
    change: '+15.6%',
    period: '30 days'
  }
]
</script>
